import type { CSSProperties, MouseEvent } from "react";
import { assets } from "../../assets";
import { BrandImage } from "../BrandImage/BrandImage";
import { Icon } from "../../icons";

const CLOSE_BUTTON_STYLE: CSSProperties = { marginRight: 12 };

interface SidebarDrawerHeadProps {
  brandIcon?: string;
  product: string;
  homeHref: string;
  onHome?: () => void;
  onClose?: () => void;
}

/** The sidebar's top row: the brand, and on mobile the button that closes the drawer. */
export function SidebarDrawerHead({ brandIcon, product, homeHref, onHome, onClose }: SidebarDrawerHeadProps): React.JSX.Element {
  return (
    <div className="nb-side-drawer-head">
      <SidebarBrand brandIcon={brandIcon} product={product} homeHref={homeHref} onHome={onHome} />
      {onClose ? (
        <button type="button" className="nb-icon-btn nb-side-close" aria-label="Close menu" onClick={onClose} style={CLOSE_BUTTON_STYLE}>
          <Icon name="x" />
        </button>
      ) : null}
    </div>
  );
}

function SidebarBrand({ brandIcon, product, homeHref, onHome }: Omit<SidebarDrawerHeadProps, "onClose">): React.JSX.Element {
  function goHome(e: MouseEvent<HTMLAnchorElement>): void {
    if (!onHome || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    onHome();
  }

  return (
    <a className="nb-side-brand" href={homeHref} aria-label="Nabble Suite, go to home" onClick={goHome}>
      <BrandImage src={brandIcon ?? assets.iconDark} />
      <span className="nb-wordmark">
        <span>
          Nabble<b>_</b>
        </span>
        <small>{product}</small>
      </span>
    </a>
  );
}
